// extracted by mini-css-extract-plugin
module.exports = {"indicator":"DraftModeIndicator_indicator__dQW_j"};